import Vue from "vue";
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
    {
        name: 'stepOne',
        path: '/',
        component: require('./Components/Reservation/StepOne').default,
        props: true,
    },
    {
        name: 'stepTwo',
        path: '/options',
        component: require('./Components/Reservation/StepTwo').default,
        props: true,
        meta: {
            doRedirect: true,
        }
    },
    {
        name: 'stepThree',
        path: '/address',
        component: require('./Components/Reservation/StepThree').default,
        props: true,
        meta: {
            doRedirect: true,
        }
    },
    {
        name: 'stepOneBusiness',
        path: '/zakelijk',
        component: require('./Components/Reservation/StepOne').default,
        props: true,
        meta: {
            isBusiness: true,
        }
    },
    {
        name: 'stepTwoBusiness',
        path: '/zakelijk/options',
        component: require('./Components/Reservation/StepTwo').default,
        props: true,
        meta: {
            isBusiness: true,
            doRedirect: true,
        }
    },
    {
        name: 'stepThreeBusiness',
        path: '/zakelijk/address',
        component: require('./Components/Reservation/StepThree').default,
        props: true,
        meta: {
            isBusiness: true,
            doRedirect: true,
        }
    },
  {
    name: 'bedankt',
    path: '/bedankt',
    props: true,
    meta: {
      isBusiness: false,
    }
  },
]

const router = new VueRouter({
    base: '/reserveren',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes
});

export default router;
